import React from 'react';
import { Grid, Typography, Button } from '@mui/material';

import { OnboardingStepProps } from 'src/pages/onboarding/OnboardingPage';

interface DetailsDescriptionStepProps extends OnboardingStepProps {}

const DetailsDescriptionStep = ({ onNextStep }: DetailsDescriptionStepProps) => (
  <Grid
    container
    direction="column"
    justifyContent="center"
    alignItems="center"
    sx={{ height: '100%' }}
  >
    <div>
      <Grid item>
        <Typography align="center" sx={{ color: 'text.secondary', p: 2, mb: 12 }}>
          We just need to grab a few more details from you and we’ll be good to go
        </Typography>
      </Grid>
      <Grid item sx={{ mt: 8, display: 'flex', justifyContent: 'center' }}>
        <Button variant="contained" size="large" onClick={onNextStep}>
          Sounds good to me
        </Button>
      </Grid>
    </div>
  </Grid>
);

export default DetailsDescriptionStep;
